<div class="container-fluid my-3">
    <h3 class="mb-4">
        {{ 'titles_userAdministration' | translate: 'online' : 'userAdministration' }}
    </h3>
    @if (canCreateUser()) {
        <div class="d-flex justify-content-end mb-3">
            <button type="button" class="btn btn-primary" (click)="navigateToCreateUser()">
                <i class="bi bi-plus-circle"></i>
                {{ 'titles_createUser' | translate: 'online' : 'userAdministration' }}
            </button>
        </div>
    }

    @if (users$ | async; as view) {
        <div class="table-responsive">
            <table
                class="table table-striped mb-0"
                [ngClass]="{'table-hover': view.collectionSize > 0}">
                <thead>
                    <tr>
                        <th
                            app-sortable-table-header
                            [column]="'name'"
                            (sort)="onSort($event)"
                            [label]="
                                'properties_name' | translate: 'online' : 'userAdministration'
                            "></th>
                        <th
                            app-sortable-table-header
                            [column]="'role'"
                            (sort)="onSort($event)"
                            [label]="
                                'properties_role' | translate: 'online' : 'userAdministration'
                            "></th>
                        <th
                            app-sortable-table-header
                            [column]="'note'"
                            (sort)="onSort($event)"
                            [label]="
                                'properties_note' | translate: 'online' : 'userAdministration'
                            "></th>
                        <th class="last-col bg-transparent"></th>
                    </tr>
                    <tr [formGroup]="formGroup">
                        <td class="align-top">
                            <app-input-text-group formControlName="name"></app-input-text-group>
                        </td>
                        <td class="align-top">
                            <app-input-dropdown-checkboxes
                                formControlName="roles"></app-input-dropdown-checkboxes>
                        </td>
                        <td class="align-top">
                            <app-input-text-group formControlName="note"></app-input-text-group>
                        </td>
                        <td class="last-col bg-transparent align-top"></td>
                    </tr>
                </thead>
                <tbody class="text-nowrap">
                    @for (user of view.users; track user.loginNameId) {
                        <tr
                            style="cursor: pointer"
                            (click)="navigateToUser(user)"
                            class="align-middle">
                            <td class="py-3">{{ user.personName ?? '(' + user.userName + ')' }}</td>
                            <td class="py-3">
                                @if (user.role.toLowerCase() === 'administrator') {
                                    {{
                                        'properties_roles.administrator'
                                            | translate: 'online' : 'userAdministration'
                                    }}
                                } @else if (user.role.toLowerCase() === 'user') {
                                    {{
                                        'properties_roles.user'
                                            | translate: 'online' : 'userAdministration'
                                    }}
                                } @else {
                                    {{ user.role }}
                                }
                            </td>
                            <td class="py-3" [title]="user.noteFull">{{ user.noteDisplay }}</td>
                            <td class="text-end py-3"><i class="bi bi-chevron-right"></i></td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="4" class="text-center text-muted py-5">
                                {{ 'table_noResults' | translate: 'online' : 'common' }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <div class="text-center mt-3">
            <app-pagination
                [collectionSize]="view.collectionSize"
                [page]="page()"
                [pageSize]="pageSize()"
                (pageChange)="setPage($event)"
                (pageSizeChange)="setPageSize($event)">
            </app-pagination>
        </div>
    } @else {
        <app-load />
    }
</div>
